import axios from "axios";

const mentoriaURL = process.env.MENTORIA_FINANCIERA_URL;
const mentoriaApiKey = process.env.MENTORIA_FINANCIERA_API_KEY;
const tokenURL = process.env.URL_COMFAMA_TOKEN;
const tokenApiKey = process.env.URL_COMFAMA_TOKEN_KEY;

export const getToken = async (uid: string) => {
   if (tokenURL) {
      const response = await axios.post(
         tokenURL,
         {
            action: "getJWT",
            UID: uid,
         },
         {
            headers: {
               "Content-Type": "application/json;charset=UTF-8",
               ApiKey: tokenApiKey,
            },
         }
      );

      return response.data.data;
   }
};

//TODO: Descomentar para que la petición vaya al lugar correcto
export const getQuestionsByPurposes = async (purposes: any, jwt: string) => {
   return await axios.post(mentoriaURL + "getQuestionsByPurpose", purposes, {
      headers: {
         "Content-Type": "application/json;charset=UTF-8",
         ApiKey: mentoriaApiKey,
         Authorization: `Bearer ${jwt}`,
      },
   });
};

// export const getQuestionsByPurposes = async (purposes: any, jwt: string) => {
//    return await axios.post(
//       "https://1p19s0g9rb.execute-api.us-east-1.amazonaws.com/dev/mentoria/questions/api/v1.0/getQuestionsByPurpose",
//       purposes,
//       {
//          headers: {
//             "Content-Type": "application/json;charset=UTF-8",
//             Authorization: `Bearer ${jwt}`,
//          },
//       }
//    );
// };

export const postResponsesPurposes = async (jwt: string, payload: any) => {
   return await axios.post(mentoriaURL + "saveQuestionsByPurposes", payload, {
      headers: {
         "Content-Type": "application/json",
         ApiKey: mentoriaApiKey,
         Authorization: `Bearer ${jwt}`,
      },
   });
};

//TODO: Descomentar para que la petición vaya al lugar correcto
export const getDiagnosticQuestions = async (jwt: string) => {
   return await axios.get(mentoriaURL + "getDiagnosticQuestions", {
      headers: {
         "Content-Type": "application/json",
         ApiKey: mentoriaApiKey,
         Authorization: `Bearer ${jwt}`,
      },
   });
};

// export const getDiagnosticQuestions = async (jwt: string) => {
//    return await axios.get(
//       "https://1p19s0g9rb.execute-api.us-east-1.amazonaws.com/dev/mentoria/questions/api/v1.0/getDiagnosticQuestions",
//       {
//          headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${jwt}`,
//          },
//       }
//    );
// };

export const getResults = async (jwt: string) => {
   return await axios.get(mentoriaURL + "getDiagnosticResult", {
      headers: {
         "Content-Type": "application/json",
         ApiKey: mentoriaApiKey,
         Authorization: `Bearer ${jwt}`,
      },
   });
};

// export const getResults = async (jwt: string) => {
//    return await axios.get(
//       "https://1p19s0g9rb.execute-api.us-east-1.amazonaws.com/dev/mentoria/questions/api/v1.0/getDiagnosticResult",
//       {
//          headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${jwt}`,
//          },
//       }
//    );
// };

export const postResponsesDiagnostic = async (jwt: string, payload: any) => {
   return await axios.post(mentoriaURL + "saveResponses", payload, {
      headers: {
         "Content-Type": "application/json",
         ApiKey: mentoriaApiKey,
         Authorization: `Bearer ${jwt}`,
      },
   });
};

export const postSendOtp = async (jwt: string, payload: any) => {
   return await axios.post(mentoriaURL + "sendOtp", payload, {
      headers: {
         "Content-Type": "application/json",
         ApiKey: mentoriaApiKey,
         Authorization: `Bearer ${jwt}`,
      },
   });
};

export const postValidateOtp = async (jwt: string, payload: any) => {
   return await axios.post(mentoriaURL + "validateOtp", payload, {
      headers: {
         "Content-Type": "application/json",
         ApiKey: mentoriaApiKey,
         Authorization: `Bearer ${jwt}`,
      },
   });
};

export const acceptCAC = async (jwt: string) => {
   return await axios.post(
      mentoriaURL + "wayToMyHouse",
      {
         toAccept: true,
      },
      {
         headers: {
            "Content-Type": "application/json",
            ApiKey: mentoriaApiKey,
            Authorization: `Bearer ${jwt}`,
         },
      }
   );
};
